'use client';

import type { VariantKey } from '@libs/common-types';

import { VariantBaseButton } from './variant-base-button';
import { VariantColorButton } from './variant-color-button';

type VariantOptionProps = {
    value: string;
    display: string;
    variantType: VariantKey;
    isChecked: boolean;
    isUnavailable: boolean;
    handleChangeAction: () => void;
};

export const VariantOption = ({
    value,
    display,
    variantType,
    isChecked,
    isUnavailable,
    handleChangeAction,
}: VariantOptionProps) => {
    if (variantType === 'color') {
        return (
            <VariantColorButton
                name="variant-color"
                value={value}
                isChecked={isChecked}
                onChange={handleChangeAction}
                label={display ?? value}
                colors={value.toLowerCase().split(',')}
                isUnavailable={isUnavailable}
            />
        );
    }

    return (
        <VariantBaseButton
            name={variantType}
            value={value}
            isChecked={isChecked}
            onChange={handleChangeAction}
            label={display ?? value}
            isUnavailable={isUnavailable}
        />
    );
};
